/**
 * Пиксельный сундучок — награда за пройденные темы грамматики (владелец 2026-10-23: «показать бонусную систему: проходи
 * темы — получишь награду»). Сетка 16×16 в стиле игры, `crispEdges` держит пиксели чёткими.
 */
const GRID = [
  '................',
  '................',
  '...oooooooooo...',
  '..obbbbbbbbbbo..',
  '.obbbbbbbbbbbbo.',
  '.oyyyyyyyyyyyyo.',
  '.obbbbbccbbbbbo.',
  '.obbbbbccbbbbbo.',
  '.oyyyyyyyyyyyyo.',
  '.obbbbbbbbbbbbo.',
  '.obbbbbbbbbbbbo.',
  '.obbbbbbbbbbbbo.',
  '.oooooooooooooo.',
  '................',
  '................',
  '................',
];

const COLORS: Record<string, string> = {
  o: '#1b1a26',
  b: '#8a5a2b',
  y: '#f2c14e',
  c: '#f4ecd8',
};

export function PixelChestIcon({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 16 16" shapeRendering="crispEdges" className={className} aria-hidden>
      {GRID.flatMap((row, y) =>
        [...row].map((cell, x) =>
          COLORS[cell] ? <rect key={`${x}-${y}`} x={x} y={y} width={1} height={1} fill={COLORS[cell]} /> : null,
        ),
      )}
    </svg>
  );
}
